export default function(_) {
  return _ === Object(_);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/isObject.js
// module id = 872
// module chunks = 0